import { useLocalStorage } from '@portals/shared-frontend/hooks';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { isSignedInWithAzure, loginRequest, msalInstance } from '@/auth/azure';
import CenteredProgressIndicator from '@/components/ProgressIndicator';
import AuthContext from '@/hooks/AuthContext';
import useReturnTo from '@/hooks/useReturnTo';

export default function SsoAzureLogin() {
  const [, setLastLoggedInEmail] = useLocalStorage(`last-logged-in-internal-user-email`, '');
  const navigate = useNavigate();
  const [returnTo] = useReturnTo();
  const { refresh: refreshAuth } = useContext(AuthContext);

  useEffect(() => {
    const handleRedirectOrLogin = async () => {
      const redirectResponse = await msalInstance.handleRedirectPromise();
      // Login was successful and user was redirected back to the Developer Portal
      if (redirectResponse) {
        setLastLoggedInEmail(redirectResponse.account.username);
        await refreshAuth();
        // User is logged in. Returning to previous page
        navigate(returnTo ?? '/');
      } else {
        try {
          const isLoggedInWithAzure = await isSignedInWithAzure();
          if (isLoggedInWithAzure) {
            // User is already logged in. Returning to previous page
            navigate(returnTo ?? '/');
          } else {
            // Check if another login is in process before initiating a new
            if (!sessionStorage.getItem('msal.interaction.status')) {
              await msalInstance.loginRedirect(loginRequest);
            }
          }
        } catch {
          navigate('/login/failure');
        }
      }
    };
    void handleRedirectOrLogin();
  }, [navigate, refreshAuth, returnTo, setLastLoggedInEmail]);

  return <CenteredProgressIndicator />;
}
